import useGetMappingByControl from "./useGetMappingByControl";

const useSetActualizeDataFromDataGrid = () => {
  const getMappingByControl = useGetMappingByControl();
  
  const setActualizeDataFromDataGrid = (updatedFormData, dataGridId, nRows) => { 
    if (!updatedFormData.metaData) return;
    updatedFormData.metaData.map(control =>{
      
      if (control.type == "ListBox" || control.type == "AutoComplete" || control.type == "DataGrid") {
        
        if (control.properties.data.option) {
          const currentMapping = getMappingByControl(control)
         
          if (currentMapping && currentMapping.value.includes(dataGridId) ) {
            control.properties.actualize.value = control.properties.actualize.value + 1
            control.properties.size.value = nRows
          }
        }
      }

      setActualizeDataFromDataGrid(control, dataGridId, nRows)
    })
    
  }

  return setActualizeDataFromDataGrid;
};

export default useSetActualizeDataFromDataGrid;
